import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect } from "react";
import ReactDOM from "react-dom";

interface DocumentPreviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    fileUrl: string | null;
    fileType: string | null;
}

const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({ isOpen, onClose, fileUrl, fileType }) => {
    const isImage = fileType?.startsWith("image/");
    const isPdf = fileType === "application/pdf";

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [isOpen]);

    return ReactDOM.createPortal(
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog
                as="div"
                className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-md"
                onClose={onClose}
            >
                {/* Full-Screen Modal */}
                <Dialog.Panel className="relative w-full h-full max-w-6xl max-h-[95vh] bg-white shadow-2xl rounded-xl overflow-hidden flex flex-col">

                    {/* Close Button */}
                    <button
                        className="absolute top-4 right-4 bg-red-500 text-white px-3 py-2 rounded-full shadow-lg hover:bg-red-600 hover:scale-110 transition"
                        onClick={onClose}
                    >
                        ✖
                    </button>

                    {/* Header */}
                    <div className="text-xl font-semibold text-gray-700 py-4 text-center border-b bg-gray-100">
                        Document Preview
                    </div>

                    {/* Content Area */}
                    <div className="flex-1 flex items-center justify-center bg-gray-100">
                        {fileUrl ? (
                            isPdf ? (
                                <iframe
                                    src={fileUrl}
                                    title="Document Preview"
                                    width="100%"
                                    height="100%"
                                    className="border-none rounded-lg"
                                />
                            ) : isImage ? (
                                <img src={fileUrl} alt="Preview" className="max-w-full max-h-full object-contain rounded-lg shadow-md" />
                            ) : (
                                <p className="text-gray-500">Unsupported file type</p>
                            )
                        ) : (
                            <p className="text-gray-500">No file selected</p>
                        )}
                    </div>
                </Dialog.Panel>
            </Dialog>
        </Transition>,
        document.body
    );
};

export default DocumentPreviewModal;
